export const xsmall = { max: 349, min: 0 };
export const small = { max: 769, min: 350 };
export const medium = { max: 1024, min: 769 };
export const large = { max: 1366, min: 1025 };
export const xlarge = { max: 1600, min: 1367 };
export const xsmallMax = `max-width: ${xsmall.max}px`;
export const smallMax = `max-width: ${small.max}px`;
export const mediumMax = `max-width: ${medium.max}px`;
export const largeMax = `max-width: ${large.max}px`;
export const xlargeMax = `max-width: ${xlarge.max}px`;
export const xsmallMin = `min-width: ${xsmall.min}px`;
export const smallMin = `min-width: ${small.min}px`;
export const mediumMin = `min-width: ${medium.min}px`;
export const largeMin = `min-width: ${large.min}px`;
export const xlargeMin = `min-width: ${xlarge.min}px`;

